import generateRandomKeyClass from './generateRandomKey';
import connectClass from  './connect';

export const connect = connectClass;
export const generateRandomKey = generateRandomKeyClass;


export const getDisplayName = WrappedComponent => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}



// WEBPACK FOOTER //
// ./src/editor/layout/utils/index.js